import styled from 'styled-components';
import Image from 'components/Base/Image';

export const SImage = styled(Image)`
  object-fit: cover;
`;
